import {Skeleton} from '@ds/components';

const SelectProductsListItemSkeleton: React.FC = () => {
  return (
    <div className="flex items-center gap-2.5">
      <div className="flex size-12 items-center justify-center">
        <Skeleton.Button active size="small" className="size-5" />
      </div>
      <div className="flex w-full flex-col gap-1 border-b border-gray-22 py-2 pe-4">
        <Skeleton active paragraph={{rows: 0}} title={{width: '70%'}} />
        <div className="flex items-start justify-between">
          <Skeleton.Button active size="small" className="h-5 w-15" />
          <Skeleton.Button active size="small" className="h-5 w-12.5" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton.Button active size="small" className="h-4 w-20" />
          <Skeleton.Button active size="small" className="h-5 w-10" />
        </div>
      </div>
    </div>
  );
};

export default SelectProductsListItemSkeleton;
